import {v4 as uuidv4} from 'uuid';
import img1 from '../../assets/img/icons/ACommitmenttoQualityFairTrade.svg';
import img2 from '../../assets/img/icons/AdvancedTechnologyProcesses.svg';
import img3 from '../../assets/img/icons/Customer-CentricApproach.svg';


const servicesThreeData = [
    {
        id: uuidv4(),
        img: img1,
        title: 'A Commitment to Quality & Fair Trade ',
        desc: 'At Shree Gita Group, our expertise begins at the source—working directly with farmers to ensure they receive fair pricing while also offering guidance on crop management best practices. This approach ensures a consistent supply of high-quality products for our customers. ',
    },

    {
        id: uuidv4(),
        img: img2,
        title: 'Advanced Technology & Processes   ',
        desc: 'We have developed state-of-the-art ginning capabilities across all sourcing locations. Our focus is on producing premium-grade cotton tailored to meet global market needs. Flexibility and customization are key pillars of our process, allowing us to cater to specific customer requirements. ',
    },

    {
        id: uuidv4(),
        img: img3,
        title: 'Customer-Centric Approach  ',
        desc: 'Customer satisfaction has always been at the heart of Shree Gita Group. Our well-established marketing, distribution, and customer service network enables us to deliver reliable and exceptional service, building long-term trust with our clients. ',
    },
    
    
    
]

export default servicesThreeData;